
import { defineComponent } from 'vue'

import { Form as VForm, Field as VField } from 'vee-validate'

import AsInput from '@web/components/AsInput/AsInput.vue'
import AsPhoneInput from '@web/components/AsPhoneInput.vue'
import AsRadio from '@web/components/AsRadio.vue'
import AsAvatarUpload from '@web/components/AsAvatarUpload.vue'
import AsNotice from '@web/components/AsNotice.vue'
import AsSelect from '@web/components/AsSelect.vue'
import AsDateSelect from '@web/components/AsDateSelect.vue'

import useErrors from '@web/composition/useErrors'
import useUserProfile from '@web/composition/useUserProfile'

export default defineComponent({
  components: {
    AsDateSelect,
    AsInput,
    AsPhoneInput,
    AsSelect,
    AsRadio,
    AsAvatarUpload,
    AsNotice,
    VForm,
    VField
  },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    classTitle: {
      type: String,
      default: () => 'lUserEdit_title'
    }
  },
  emits: ['submit'],
  setup (props, ctx) {
    const {
      serverErrors,
      displayServerErrors,
      getFirstError
    } = useErrors()

    const scrollToError = (): void => {
      const errorEl: HTMLElement | null = document.querySelector('.asInput_error')
      if (errorEl && errorEl.parentElement) {
        errorEl.parentElement.scrollIntoView()
      }
    }

    return {
      serverErrors,
      getFirstError,
      scrollToError,
      ...useUserProfile({
        serverErrors,
        displayServerErrors,
        emit: ctx.emit
      })
    }
  }
})
